import Footer from '../app/Footer';
import Navbar from '../navigation/Navbar';
import PageNotFoungImg from '../../images/404.jpg';
import './UnorderedList.scss'

function PageNotFound() {
    return (
        <div >
            <Navbar></Navbar>
            <div style={{display: 'flex'}}>
                <img style={{width: "90vw", margin: '0 auto'}} src={PageNotFoungImg} alt='404 Page Not Found'/>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default PageNotFound;